module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.step !== 'CAPTURA') ? _c('div', {
    staticClass: "container-fluid selfie"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-10 col-sm-8 mx-auto selfie-form"
  }, [_c('router-link', {
    staticClass: "content-logo-principal",
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "href": "https://royalpag.com"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "src": _vm.img
    }
  })])])])]), _vm._v(" "), (_vm.step === 'START') ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2 msg-title"
  }, [_vm._v("\n              Agora precisamos de uma selfie sua, fique atento às instruções:\n            ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body pt-0"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-start mb-3",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.startCapture()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-camera fa-2x float-left pr-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-start-align"
  }, [_vm._v("Iniciar captura")])])]), _vm._v(" "), _c('p', {
    staticClass: "text-center text-default-gray msg-sub-title"
  }, [_vm._v("\n              Ou complete seu cadastro utilizando as opções:\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block btn-start mb-3",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendSMS()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-2x float-left pr-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-start-align"
  }, [_vm._v("Enviar SMS")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block btn-start mb-3",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.scanQRCode()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode fa-2x float-left pr-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-start-align"
  }, [_vm._v("Escanear QR Code")])])]) : _vm._e(), _vm._v(" "), (_vm.step === 'ERRO_FOTO') ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2 msg-title"
  }, [_vm._v(_vm._s(_vm.errorMessage ? _vm.errorMessage : 'Não foi possível processar a sua selfie, por favor tente novamente'))]), _vm._v(" "), _c('div', {
    staticClass: "card-body pt-0"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-start mb-3",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.restartCapture()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-camera fa-2x float-left pr-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-start-align"
  }, [_vm._v("Reiniciar captura")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body pt-0",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-family": "Roboto",
      "font-size": "14px"
    }
  }, [_vm._v("\n                  Está com dificuldade na captura? Temos outras opções, "), _c('strong', [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.otherOptions()
      }
    }
  }, [_vm._v("clique aqui!")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 'ERRO_CAMERA' || _vm.step === 'OUTRAS_OPCOES' || _vm.step === 'OUTRAS_OPCOES_LIMITE_TENTATIVAS' || _vm.step === 'ERRO_SMS' || _vm.step === 'ERRO_QRCODE') ? _c('div', [(_vm.step === 'ERRO_CAMERA') ? _c('h2', {
    staticClass: "text-center text-default-gray logo_h2 msg-title"
  }, [_vm._v("\n              Infelizmente não conseguimos abrir sua câmera, mas você pode completar seu cadastro utilizando as opções abaixo\n            ")]) : _vm._e(), _vm._v(" "), (_vm.step === 'OUTRAS_OPCOES') ? _c('h2', {
    staticClass: "text-center text-default-gray logo_h2 msg-title"
  }, [_vm._v("\n              Você pode completar seu cadastro utilizando as opções abaixo\n            ")]) : _vm._e(), _vm._v(" "), (_vm.step === 'OUTRAS_OPCOES_LIMITE_TENTATIVAS') ? _c('h2', {
    staticClass: "text-center text-default-gray logo_h2 msg-title"
  }, [_vm._v("\n              Não conseguimos processar a sua selfie, no entanto você pode completar seu cadastro "), _c('strong', [_vm._v("utilizando as opções abaixo:")])]) : _vm._e(), _vm._v(" "), (_vm.step === 'ERRO_SMS') ? _c('h2', {
    staticClass: "text-center text-default-gray logo_h2 msg-title"
  }, [_vm._v("\n              Não conseguimos enviar o SMS para seu celular, tente novamente em alguns instantes\n            ")]) : _vm._e(), _vm._v(" "), (_vm.step === 'ERRO_QRCODE') ? _c('h2', {
    staticClass: "text-center text-default-gray logo_h2 msg-title"
  }, [_vm._v("\n              Não conseguimos gerar o código QR Code, tente novamente em alguns instantes\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-body pt-0"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-start mb-3",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendSMS()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope fa-2x float-left pr-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-start-align"
  }, [_vm._v("Enviar SMS")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block btn-start mb-3",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.scanQRCode()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-qrcode fa-2x float-left pr-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-start-align"
  }, [_vm._v("Escanear QR Code")])]), _vm._v(" "), (_vm.cameraDenied) ? _c('button', {
    staticClass: "btn btn-primary btn-block btn-start mb-3",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.startCapture()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-camera fa-2x float-left pr-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-start-align"
  }, [_vm._v("Reiniciar captura")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block btn-start mb-3",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.backToHome()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-2x float-left pr-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-start-align"
  }, [_vm._v("Voltar")])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 'FINALIZADO') ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2 pb-5",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("Sua conta foi criada e já pode ser utilizada através do botão abaixo, muito obrigado!")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block btn-normal",
    style: (_vm.color),
    attrs: {
      "type": "reset",
      "value": "Entrar"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.entrar.apply(null, arguments)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step === 'ENVIANDO_SMS') ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2 pb-5",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("\n              Enviando SMS para seu número de cadastro, aguarde ...\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.step === 'FINALIZADO_SMS') ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2 pb-5",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("Você receberá um SMS com o link para completar seu cadastro, muito obrigado!")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block btn-normal",
    style: (_vm.color),
    attrs: {
      "type": "reset",
      "value": "Entrar"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.entrar.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-block btn-normal",
    attrs: {
      "type": "reset",
      "value": "Voltar"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.backToHome.apply(null, arguments)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step === 'GERANDO_QRCODE') ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2 pb-5",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("\n              Gerando QR Code, aguarde ...\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.step === 'FINALIZADO_QRCODE') ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2 pb-5",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("Para escanear o código QR utilize a câmera do seu celular e abra o link que será exibido, muito obrigado!")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "margin": "0 auto 30px auto",
      "width": "180px"
    },
    attrs: {
      "src": _vm.qrcode
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block btn-normal",
    style: (_vm.color),
    attrs: {
      "type": "reset",
      "value": "Entrar"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.entrar.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary btn-block btn-normal",
    attrs: {
      "type": "reset",
      "value": "Voltar"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.backToHome.apply(null, arguments)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.step === 'FOTO_VERIFICADA') ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2 pb-5",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("Você já realizou o processo de verificação da foto, muito obrigado!")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block btn-normal",
    style: (_vm.color),
    attrs: {
      "type": "reset",
      "value": "Entrar"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.entrar.apply(null, arguments)
      }
    }
  })])]) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.step === 'CAPTURA') ? _c('div', [_c('the-camera-selfie')], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticStyle: {
      "list-style": "inside",
      "margin-bottom": "20px",
      "font-family": "Roboto",
      "font-size": "14px"
    }
  }, [_c('li', [_vm._v("Retire óculos e chapéu.")]), _vm._v(" "), _c('li', [_vm._v("Enquadre seu rosto na área demarcada.")]), _vm._v(" "), _c('li', [_vm._v("Esteja em um local iluminado.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center text-default-gray msg-sub-title"
  }, [_vm._v("\n              Não se preocupe,\n              "), _c('strong', [_vm._v("essa foto não será divulgada")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78347391","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/auth/selfie.vue
// module id = ilcl
// module chunks = 36